import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

interface MonthlyCommissionData {
  year: number | null;
  month: string;
  total_transactions: number;
  total_commission: number;
}

interface MonthlyCommissionResponse {
  data: MonthlyCommissionData[];
}

const useFetchMonthlyCommission = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [monthlyCommission, setMonthlyCommission] = useState<MonthlyCommissionData[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined | null>(null);

  useEffect(() => {
    const fetchMonthlyCommission = async () => {
      try {
        const tk = await getAccessTokenSilently();
 
        const response = await axios.get<MonthlyCommissionResponse>(
          `${apiUrl}/api/v1/admin/profile/commission/monthly`,
          {
            headers: {
              Authorization: `Bearer ${tk}`,
            },
          }
        );
        setMonthlyCommission(response.data.data);
      } catch (err) {
        setError("Error fetching monthly commission");
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated) {
      fetchMonthlyCommission();
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return { monthlyCommission, loading, error };
};

export default useFetchMonthlyCommission;
